export default "__VITE_ASSET__BLWOlOZR__"